var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoWindow',{attrs:{"opened":_vm.opened,"position":_vm.position,"options":{
    pixelOffset: {
      width: 0,
      height: -25
    }
  }},on:{"closeclick":_vm.onClose}},[_c('div',{staticClass:"flex flex-col p-1 text-sm text-copy"},_vm._l((_vm.statusItems),function(s){return _c('div',{key:s.status,staticClass:"flex pb-1"},[_c('p',{staticClass:"font-bold",style:({color: s.color})},[_vm._v(" "+_vm._s(s.count)+" ")]),_c('img',{staticClass:"h-8 w-8",attrs:{"src":require(`@/assets/img/marker-${s.status}.svg`)}}),_c('p',[_vm._v(_vm._s(_vm.$t(s.copy)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }